import { useNavigate } from 'react-router-dom';
import axiosInstance from '../utils/axiosInstance';
import Button from '@mui/material/Button';
import Logout from '@mui/icons-material/Logout';

const LogoutButton = () => {
  const navigate = useNavigate();

  const logout = async () => {
    try {
      await axiosInstance.post(`/auth/logout`);
      navigate('/login', { replace: true });
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <Button
      variant="outlined"
      color="primary"
      onClick={logout}
      startIcon={<Logout />}
    >
      ログアウト
    </Button>
  );
};

export default LogoutButton;
